module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/headers/headers.component.scss
// module id = ./src/app/headers/headers.component.scss
// module chunks = main